<!--<app-header-->
<!--  (backToAlpha)="backToAlpha($event)"-->
<!--  (backToSAT)="backToSAT($event)"-->
<!--&gt;</app-header>-->
<!-- <app-header /> -->
<!-- <app-motor-banner (backToAlpha)="backToAlpha($event)" 
                  (backToSAT)="backToSAT($event)"
                  (signOut)="signOut($event)"
                  [user]="user$ | async"></app-motor-banner> -->
<div class="wrapper">
  <div class="body_content">
    @if (!isLoginPage) {
      <app-header [user]="user$ | async" />
    }
    <router-outlet />
    <app-loading />
  </div>
  <app-footer
    [showItHelpdesk]="showFooterHelpdesk"
    [showLegalNotes]="showFooterLegalNotes"
    [strongCopyright]="strongFooterCopyright"
    [enableScrollToTop]="showScrollTop"
  />
</div>

@if (showScrollTop) {
  <app-scroll-top></app-scroll-top>
}
